module.exports = __webpack_public_path__ + "assets/img/upload_img.cb8c3202.png";